<template>
    <div>
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item style="float: right">
                <el-button @click="currentChangeHandle(1)">刷新列表</el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="dataList"
                row-key="id"
                border
                stripe
                v-loading="dataListLoading"
                @selection-change="selectionChangeHandle"
                style="width: 100%"
        >
            <el-table-column type="selection" fixed width="55"></el-table-column>
            <el-table-column
                    fixed
                    type="index"
                    header-align="left"
                    align="left"
                    label="序号"
                    width="60"
                    :index="getRowsIndex"
            >
            </el-table-column>
            <el-table-column
                    fixed
                    prop="argName"
                    header-align="left"
                    align="left"
                    width="220"
                    label="参数名称"
            >
            </el-table-column>
            <el-table-column
                    prop="displayName"
                    header-align="left"
                    align="left"
                    label="显示名称"
            >
                <template slot-scope="scope">
                    <el-input v-model="scope.row.displayName"></el-input>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :total="totalCount"
                layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
    </div>
</template>

<script>

    import {apiCustomformFromdatasetargListSingle} from "../../server/formConfig";

    export default {
        props: {
            formId: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                dataForm: {
                    searchKey: "",
                    formId: "",
                },
                inputTypeList: ['text', 'select', 'datetime', 'number'],
                dictCateList: [],
                pageIndex: 1,
                pageSize: 10,
                totalCount: 0,
                dataList: [],
                trueOrFalseOptions: [{'text': '否', 'value': false}, {'text': '是', 'value': true}],
                dataListLoading: false,
                dataListSelections: [],
            };
        },
        activated() {

        },
        mounted() {
            this.dataForm.formId = this.formId;
            this.getDataList();
        },
        methods: {
            getRowsIndex(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1;
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val;
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true;
                const params = {
                    filter: {
                        formId: this.dataForm.formId,
                    },
                    page: this.pageIndex,
                    rows: this.pageSize,
                    searchKey: this.dataForm.searchKey,
                }
                apiCustomformFromdatasetargListSingle(params).then(({data}) => {
                    if (data) {
                        this.dataList = data.rows;
                        this.totalCount = data.total;
                        this.pageIndex = data.pageIndex;
                    } else {
                        this.dataList = [];
                        this.totalCount = 0;
                        this.pageIndex = 1;
                    }
                    this.dataListLoading = false;
                });
            },
        },
    };
</script>
